import 'vue2-datepicker/index.css';

const DatePicker = () => import(
  /* webpackChunkName: "datepicker" */ 'vue2-datepicker'
  );

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      localesWithFirstDayOne: ['ua', 'ru']
    }
  },
  computed: {
    lang() {
      return {
        formatLocale: {
          // MMMM
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          // MMM
          monthsShort: this.translateArr(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']),
          // dddd
          weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          // ddd
          weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          // dd
          weekdaysMin: this.translateArr(['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']),
          // first day of week
          firstDayOfWeek: this.firstDayOfWeek,
        }
      }
    },
    firstDayOfWeek() {
      return this.localesWithFirstDayOne.includes(this.$store.state.currentLocale) ? 1 : 0
    },
  },
  methods: {
    translateArr(arr) {
      return arr.map(t => this.$tCalendar(t))
    }
  }
}
